import { useEffect } from 'react'
import { setThemeScope } from '@utils/theme'

/** Call from a layout that is styled for dark mode. Dark applies only while such a layout is mounted. */
export function useThemeScope() {
  useEffect(() => {
    setThemeScope(true)
    return () => setThemeScope(false)
  }, [])
}
